import { HttpClient } from 'components/http/HttpClient';
import { CheckinTrigger, CheckinType } from '@pepperhq/types-sdk';

export interface ICreateCheckinRequest {
    userId: string;
    locationId: string;
    type: CheckinType;
    trigger: CheckinTrigger;
}

export class CheckinsApi extends HttpClient {
    constructor() {
        super({
            baseURL: process.env.API_SERVER_URL,
            url: '/checkins'
        });
    }

    public async createCheckin(data: ICreateCheckinRequest) {
        return this.postRequest({
            url: '/checkins',
            data
        });
    }
}

export const checkinsApi = new CheckinsApi();
